import {
  IconArrowUp,
  IconBriefcase,
  IconBuildingStore,
  IconCash,
  IconChartBar,
  IconCheck,
  IconChevronLeft,
  IconChevronRight,
  IconFilter,
  IconLayoutGrid,
  IconListCheck,
  IconMoon,
  IconReceipt,
  IconRefresh,
  IconReportAnalytics,
  IconRocket,
  IconSearch,
  IconSparkles,
  IconSun,
  IconUserPlus,
  IconX,
} from "angular-tabler-icons/icons";

/**
 * Only the Tabler icons the landing renders. Importing the whole icon set
 * (`import * as TablerIcons`) pulled every SVG into the initial bundle and
 * blew the 1 MB budget; named imports let the bundler drop the rest.
 *
 * Add here when a template or `landing-1.section-data.ts` references a new
 * `<i-tabler name="...">`; an unregistered name renders nothing.
 */
export const landingTablerIcons = {
  IconArrowUp,
  IconBriefcase,
  IconBuildingStore,
  IconCash,
  IconChartBar,
  IconCheck,
  IconChevronLeft,
  IconChevronRight,
  IconFilter,
  IconLayoutGrid,
  IconListCheck,
  IconMoon,
  IconReceipt,
  IconRefresh,
  IconReportAnalytics,
  IconRocket,
  IconSearch,
  IconSparkles,
  IconSun,
  IconUserPlus,
  IconX,
};
